// prettier-ignore
export const REFERRAL_CODES_DICT = {
  // Диана
  'Y1JUNHUF': 'Сайт',
  'OYEY7JO7': 'Болт',
  '3SB01HD8': 'Убер',
  'WG1KBTCA': 'QR код',
  'GIJCDMLI': 'Рекрутер',
  'BE3DNRD5': 'Глово',
  'SICHPKFX': 'Антон',
  'E5ENR7JL': 'Инстаграм/Фейсбук',
  'GKIVPRGO': 'Andrew',
  'VEDW1ZZS': 'Входящие звонки',
  // Юрий
  'UU6LBMVQ': 'Сайт',
  'VQB3QPWO': 'Болт',
  '1383XBHA': 'Убер',
  '1THSZHGC': 'QR код',
  'RHGW6CLR': 'Рекрутер',
  'NU71NWRZ': 'Глово',
  'DMIFFUDJ': 'Антон',
  'PWKLGGBI': 'Эндрю',
  'GL3PBFK2': 'Instagram/Facebook',
  'CBLFTLMI': 'Все входящие звонки',
};
